module.exports = __webpack_public_path__ + "static/img/face.44e4157e.png";